// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210019/js/" + chunkId + "." + {"44":"6d6f14db","225":"f70d0db6","481":"9cf9d641","486":"78aa2d4d","770":"5a0a45b6"}[chunkId] + ".0.32671449287796717.chunk.js";
};